export const BANNER = 'banner';
